import React from 'react';
import { Minus, Plus } from 'lucide-react';

/**
 * Kompaktan birač količine (lista proizvoda, detalj, korpa).
 */
export function QuantityStepper({
  value,
  onChange,
  min = 1,
  max,
  disabled = false,
  label,
  className = '',
  size = 'default',
}) {
  const effectiveMax = typeof max === 'number' && Number.isFinite(max) ? max : Number.MAX_SAFE_INTEGER;
  const clamp = (n) => Math.max(min, Math.min(effectiveMax, n));

  const pad = size === 'sm' ? 'px-2.5 py-1.5' : 'px-3 py-2';
  const icon = size === 'sm' ? 14 : 16;
  const inputW = size === 'sm' ? 'w-10' : 'w-12';

  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {label ? (
        <span className="text-xs font-ui text-muted-foreground">{label}</span>
      ) : null}
      <div className="flex items-center border border-border rounded-xl overflow-hidden w-fit max-w-full bg-background">
        <button
          type="button"
          onClick={() => onChange(clamp(value - 1))}
          disabled={disabled || value <= min}
          className={`${pad} hover:bg-muted transition-colors disabled:opacity-40 disabled:pointer-events-none`}
          aria-label="Smanji količinu"
        >
          <Minus size={icon} className="text-foreground" />
        </button>
        <input
          type="number"
          aria-label="Količina"
          className={`${inputW} text-center font-ui font-semibold text-sm text-foreground bg-transparent border-none outline-none py-2 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none`}
          value={value}
          min={min}
          max={max}
          disabled={disabled}
          onChange={(e) => {
            const v = e.target.value;
            if (v === '') {
              onChange(min);
              return;
            }
            const raw = parseInt(v, 10);
            if (Number.isNaN(raw)) return;
            onChange(clamp(raw));
          }}
        />
        <button
          type="button"
          onClick={() => onChange(clamp(value + 1))}
          disabled={disabled || value >= effectiveMax}
          className={`${pad} hover:bg-muted transition-colors disabled:opacity-40 disabled:pointer-events-none`}
          aria-label="Povećaj količinu"
        >
          <Plus size={icon} className="text-foreground" />
        </button>
      </div>
    </div>
  );
}
